import {styled} from '@mui/material';

export const StyledInput = styled('input')(() => ({}));

export const StyledLabel = styled('label')(() => ({}));
